module.exports = __webpack_public_path__ + "static/media/growth.1e5f06e3.svg";